import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0a566dbc&scoped=true&"
import script from "./create.vue?vue&type=script&lang=ts&"
export * from "./create.vue?vue&type=script&lang=ts&"
import style0 from "./create.vue?vue&type=style&index=0&id=0a566dbc&prod&lang=scss&"
import style1 from "./create.vue?vue&type=style&index=1&id=0a566dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a566dbc",
  null
  
)

export default component.exports